<template>
<div class="warning-right pr-2 py-1">
  <div class="warning-right__content pl-2">
    <div class="warning-right__title">Achtung! Sie beenden eine bestehende Kooperation.</div>
    <div class="warning-right__text">
      Das kann Kosten verursachen. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis
      consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.
      <a>Allgemeine Gschäftsbedingungen.</a>
    </div>
  </div>
  <div class="warning-right__warning d-flex pl-2">
    <div class="warning-right__warning-icon">
      <WarningIcon/>
    </div>
    <div class="warning-right__warning-text">
      Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet!
    </div>
  </div>
</div>
</template>

<script>
import WarningIcon from "@/components/icons/WarningIcon";
export default {
  name: "WarningRightExample",
  components: {WarningIcon}
}
</script>

<style scoped lang="scss">
.warning-right {

  &__content {
    margin-bottom: $spacer / 2;
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
  }

  &__text {
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;

    a {
      color: map-get($blue, 'lighten-1');
      text-decoration: underline;
    }
  }

  &__warning {
    &-icon {
      margin-top: 4px;
      margin-left: -32px;
      flex: 0 0 32px;
      width: 32px;
    }

    &-text {
      color: map-get($pink, 'darken-1');
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
    }
  }
}
</style>
